  <template>
  <div class="dashboard">
    <div class="container">
      <div class="text-center mb-4">
        <hr class="space space-sm">
        <p class="medium mb-0 text-muted">Welcome</p>
        <h2>{{ user.first_name|defvalue('there') }}!</h2>
      </div>

      <!-- <ul class="nav nav-tabs nav-justified nav-clients small medium">
        <li class="nav-item">
          <a class="nav-link" @click.prevent="setActive('projects')" :class="{ active: isActive('projects') }" href="#">
            <img v-if="isActive('projects')" src="/static/images/icons/projects.svg" alt="">
            <img v-else src="/static/images/icons/projects_inactive.svg" alt="">
            <br>
            <span>My projects</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" @click.prevent="setActive('referrals')" :class="{ active: isActive('referrals') }" href="#">
            <img v-if="isActive('referrals')" src="/static/images/icons/referrals.svg" alt="">
            <img v-else src="/static/images/icons/referrals_inactive.svg" alt=""><br>
            <span>My referrals</span>
          </a>
        </li>
      </ul> -->
    </div>

    <div class="container">
      <div class="tab-content py-3" id="myTabContent">
        <vue-page-transition name="fade">
          <router-view></router-view>
        </vue-page-transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'dashboard-base',
  data () {
    return {
      activeItem: 'projects'
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  mounted () {
    window.scrollTo(0, 0)
    this.updateActive()
  },
  watch: {
    '$route' () {
      this.updateActive()
    }
  },
  methods: {
    updateActive () {
      let name = this.$router.currentRoute.name
      this.activeItem = name.replace('dashboard-', '')
    },
    isActive (menuItem) {
      return this.activeItem === menuItem
    },
    setActive (menuItem) {
      this.activeItem = menuItem
      this.$router.push({ 'name': 'dashboard-' + menuItem })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
